<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :itemText="itemText"
            :autoComplete="autoComplete"
            :dense="dense"
        />
        <sys-register-ambience @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectAmbience',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        itemText: {
            type: String,
            default: 'name_complete'
        },
        dense:{
            type: Boolean,
            default: false
        },
        categoryId: {
            type: Number,
        },
        campusId: {
            type: Number,
            default: 0
        },
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        campusId(val){
            this.getItems();
        },

        categoryId(val){
            this.getItems();
        },
    },
    methods: {
        ...mapActions('ambience', ['ActionFindAmbiences']),        
        
        async getItems() {

            if(this.campusId == -1){
                this.items = [];
                return;
            }
            
            this.loading = true;
            let payload = {
                find_columns: {
                    active: 1
                }
            };

            if(this.campusId){
                payload.find_columns.campus_id = this.campusId;
            }

            if(this.categoryId){
                payload.find_columns.category_ambience_id = this.categoryId;
            }

            await this.ActionFindAmbiences(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>